// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3f3qm","calendarButtons":"ClockData_calendarButtons__1k0YD"};